"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SwapController = void 0;
var neko_1 = require("../../services/neko");
var Result_1 = __importDefault(require("../../Result"));
var errors_1 = require("./errors");
/**
 * All endpoints for swap
 */
var SwapController = /** @class */ (function () {
    function SwapController() {
    }
    /**
     * Fetches order details
     */
    SwapController.getOrder = function (provider, orderId) {
        return __awaiter(this, void 0, void 0, function () {
            var data, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, neko_1.neko.swap.getOrder(provider, orderId)];
                    case 1:
                        data = _a.sent();
                        if (!data)
                            return [2 /*return*/, Result_1.default.fail(errors_1.GET_ORDER_FAIL)];
                        return [2 /*return*/, Result_1.default.ok(data)];
                    case 2:
                        error_1 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.GET_ORDER_FAIL)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Requests a quote from service
     */
    SwapController.createQuote = function (body) {
        return __awaiter(this, void 0, void 0, function () {
            var data, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, neko_1.neko.swap.createQuote(body)];
                    case 1:
                        data = _a.sent();
                        if (!data)
                            return [2 /*return*/, Result_1.default.fail(errors_1.CREATE_QUOTE_FAIL)];
                        return [2 /*return*/, Result_1.default.ok(data)];
                    case 2:
                        error_2 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.CREATE_QUOTE_FAIL)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Creates either a fixed or variable order depending on type param
     */
    SwapController.createOrder = function (type, body) {
        return __awaiter(this, void 0, void 0, function () {
            var ipAddress, location_1, _a, data, error_3;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 6, , 7]);
                        ipAddress = void 0;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, neko_1.neko.location.fetch()];
                    case 2:
                        location_1 = _b.sent();
                        ipAddress = location_1.ip;
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 4: return [4 /*yield*/, neko_1.neko.swap.createOrder(type, body, ipAddress)];
                    case 5:
                        data = _b.sent();
                        if (!data)
                            return [2 /*return*/, Result_1.default.fail(errors_1.CREATE_ORDER_FAIL)];
                        return [2 /*return*/, Result_1.default.ok(data)];
                    case 6:
                        error_3 = _b.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.CREATE_ORDER_FAIL)];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get order history for a walletId
     */
    SwapController.getOrderHistory = function (walletId) {
        return __awaiter(this, void 0, void 0, function () {
            var data, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, neko_1.neko.swap.getOrderHistory(walletId)];
                    case 1:
                        data = _a.sent();
                        if (!data)
                            return [2 /*return*/, Result_1.default.fail(errors_1.GET_ORDER_HISTORY_FAIL)];
                        return [2 /*return*/, Result_1.default.ok(data)];
                    case 2:
                        error_4 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.GET_ORDER_HISTORY_FAIL)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Save order to database to include in order history
     */
    SwapController.saveOrder = function (body) {
        return __awaiter(this, void 0, void 0, function () {
            var data, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, neko_1.neko.swap.saveOrder(body)];
                    case 1:
                        data = _a.sent();
                        if (!data)
                            return [2 /*return*/, Result_1.default.fail(errors_1.SAVE_ORDER_FAIL)];
                        return [2 /*return*/, Result_1.default.ok(data)];
                    case 2:
                        error_5 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.SAVE_ORDER_FAIL)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Fetches list of all swappable assets
     */
    SwapController.fetchSwappableAssets = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, neko_1.neko.swap.fetchSwappableAssets()];
                    case 1:
                        data = _a.sent();
                        if (!data)
                            return [2 /*return*/, Result_1.default.fail(errors_1.GET_SWAPPABLE_ASSETS_FAIL)];
                        return [2 /*return*/, Result_1.default.ok(data)];
                    case 2:
                        error_6 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.GET_SWAPPABLE_ASSETS_FAIL)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Fetches rate for specified pair of assets
     */
    SwapController.getRate = function (body) {
        return __awaiter(this, void 0, void 0, function () {
            var data, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, neko_1.neko.swap.getRate(body)];
                    case 1:
                        data = _a.sent();
                        if (!data)
                            return [2 /*return*/, Result_1.default.fail(errors_1.GET_RATE_FAIL)];
                        return [2 /*return*/, Result_1.default.ok(data)];
                    case 2:
                        error_7 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.GET_RATE_FAIL)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return SwapController;
}());
exports.SwapController = SwapController;
